module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-warn-b-6dd26f85947fa1a9dcb021dcd48c61a5.svg";